import PropTypes from 'prop-types';

export default {
  addressId: PropTypes.string,
  selectedAddressCategory: PropTypes.string,
  addressee: PropTypes.string,
  nameNumber: PropTypes.string,
  streetName: PropTypes.string,
  addressLine2: PropTypes.string,
  townCity: PropTypes.string,
  county: PropTypes.string,
  postCode: PropTypes.string,
  countryName: PropTypes.string,
  country: PropTypes.string,
  contactNumber: PropTypes.string,
};
